import React from "react";
import { PropTypes } from "prop-types";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Tooltip from "@amzn/meridian/tooltip";
import Icon from "@amzn/meridian/icon";
import { FormattedMessage, intlShape } from "react-intl";
import { getPackageSearchUrl } from "../../../utils/Helper";
import { useDeviceLayout } from "../../common/context/DeviceLayoutContext";
import CopyButton from "../../common/CopyButton";
import exportSmallTokens from "@amzn/meridian-tokens/base/icon/export-small";

function ImpactedPackages({ packageCount, trackingIds, intl, gridWidth }) {
  const { headerFont } = useDeviceLayout();

  // Handle navigation to package search
  const onPackageSearchClick = async () => {
    try {
      const searchURL = await getPackageSearchUrl();
      window.open(searchURL, "_blank");
    } catch (error) {
      console.error('Failed to navigate to package search:', error);
    }
  };

  // Early return if no package count provided
  if (!packageCount) {
    return null;
  }

  return (
    <Row
      wrap="down"
      alignmentVertical="top"
      key="impacted-packages"
      width="100%"
      alignmentHorizontal="start"
      widths={gridWidth}
    >
      <Text type={headerFont}>Impacted Packages</Text>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        {/* Package Count - First Line (no link) */}
        <div>
          <Text>{packageCount}</Text>
        </div>
        {/* Copy Tracking IDs + External Link Icon - Second Line */}
        {trackingIds && (
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Text>
              <FormattedMessage
                id="taskDetails.impactedPackages.copyTrackingIds"
                defaultMessage="Copy Tracking IDs"
              />
            </Text>
            <CopyButton
              textToCopy={trackingIds}
              size="small"
              circular={true}
            />
            <Tooltip 
              position="end" 
              title={intl.formatMessage({
                id: "taskDetails.impactedPackages.externalLinkTooltip",
                defaultMessage: "Open Package Summary Search"
              })} 
              id="impactedPackagesExternalLinkTooltip"
            >
              <Link 
                onClick={onPackageSearchClick} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Icon tokens={exportSmallTokens} />
              </Link>
            </Tooltip>
          </div>
        )}
      </div>
    </Row>
  );
}

ImpactedPackages.propTypes = {
  packageCount: PropTypes.string,
  trackingIds: PropTypes.string,
  intl: intlShape.isRequired,
  gridWidth: PropTypes.array.isRequired,
};

export default ImpactedPackages;



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskAttributes/ImpactedPackages.jsx